import React, { useState, useEffect } from "react";
import { Wrapper } from "./SelectLocation.styled";
import { Button, Row, Col, Input, Form } from "components/common";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import Geocode from "react-geocode";

const SelectLocation = ({ formData, setFormData, next, prev, isSmall }) => {
  const onFinish = () => {
    setFormData({
      ...formData,
      lat: lat,
      lng: lng,
    });

    next();
  };
  let a = `${formData?.street}, ${formData?.city} , ${formData?.state}`;
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");

  ;
  const getAddress = () => {
    Geocode.fromAddress(a).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        setLat(lat);
        setLng(lng);
      },
      (error) => {
        console.error("error", error);
      }
    );
  };
  useEffect(() => {
    if (a) {
      Geocode.setApiKey("AIzaSyDed7z5G3jV7NTuZZaCkoh6XckoQepg--k");
      getAddress();
      Geocode.enableDebug();
    }
  }, [a]);

  const MapWithAMarker = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        defaultZoom={20}
        defaultCenter={{ lat: lat, lng: lng }}
        onClick={(e) => {
          setLat(e?.latLng?.lat());
          setLng(e?.latLng?.lng());
        }}
        streetView={true}
        mapTypeId="satellite"
      >
        <Marker position={{ lat: lat, lng: lng }} />
      </GoogleMap>
    ))
  );
  return (
    <Wrapper isSmall={isSmall}>
      <div className="lead-submission-container">
        <Form
          name="basic"
          initialValues={formData}
          onFinish={onFinish}
          autoComplete="off"
        >
          {isSmall ? (<div className="sm-heading-container">
            <span className="heading-big">SELECT YOUR LOCATION</span>
          </div>) : (<div className="heading-container">
            <h2>SELECT YOUR LOCATION</h2>
          </div>)}
          <div className="form-container">
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <Form.Item
                  name="lat"
                //   rules={[
                //     { required: true, message: "Please Enter this Field!" },
                //   ]}
                >
                  <MapWithAMarker
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDed7z5G3jV7NTuZZaCkoh6XckoQepg--k&v=3.exp&libraries=geometry,drawing,places"
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: `400px` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <Row gutter={[10, 10]}>
            <Col span={12}>
              <Form.Item>
                <div >
                  <Button className="page-change-button" title="Previous" onClick={() => {
                    prev()
                  }} />
                </div>

              </Form.Item>
            </Col>
            <Col span={12}>

              <Form.Item>
                <div >
                  <Button className="page-change-button" title="Next" htmlType="submit" />
                </div>
              </Form.Item>
            </Col>
          </Row>

        </Form>
      </div>
    </Wrapper>
  );
};

export default SelectLocation;
